import { NavLink, Link } from 'react-router-dom';

export function TabletHeader({ isScrolled, navigationLinks, onMenuOpen }) {
  return (
    <div className="hidden md:flex lg:hidden items-center justify-between h-16">
      <div className="flex items-center">
        <Link to="/" className="relative group">
          <span className="text-2xl font-bold">
            <span className="text-[#7C3AED]">A</span>
            <span className={`${isScrolled ? 'text-[#06B6D4]' : 'text-white'}`}>vision</span>
            <span
              className={`block text-[10px] font-medium tracking-wider uppercase -mt-0.5 ${
                isScrolled ? 'text-white/60' : 'text-white/60'
              }`}
            >
              Commercial & Specialty Lighting · South Florida
            </span>
          </span>
        </Link>
      </div>

      <div className="flex items-center space-x-4">
        {navigationLinks.map((link) => (
          <NavLink
            key={link.path}
            to={link.path}
            className={({ isActive }) => `
              relative px-2 py-2
              text-sm font-medium
              transition-colors duration-200
              ${
                isActive
                  ? 'text-[#06B6D4]'
                  : isScrolled
                    ? 'text-white/80 hover:text-[#06B6D4]'
                    : 'text-white hover:text-[#06B6D4]'
              }
            `}
          >
            {link.label}
          </NavLink>
        ))}
        <button
          type="button"
          onClick={onMenuOpen}
          className={`
              p-2 rounded-md ml-2
              ${isScrolled ? 'text-white/80' : 'text-white'}
              hover:text-[#06B6D4]
              transition-colors
            `}
          aria-label="Open menu"
        >
          <i className="fas fa-bars text-xl" />
        </button>
      </div>
    </div>
  );
}
